import { CategoryName } from '../../@types/Products.type';
import {
	REGULARIZATION_REGARATION_PRODUCTS_SLUG,
	allRegularizationProductsSlug,
} from '../constants/SlugsProducts';

const isRegularizationProduct = (category: string, slug: string = '') => {
	if (category) {
		return category === CategoryName.DeclaraciónAtrasada;
	} else {
		return allRegularizationProductsSlug.includes(
			slug as REGULARIZATION_REGARATION_PRODUCTS_SLUG,
		);
	}
};

export { isRegularizationProduct };
